import { render } from "./BusinessUnitsDetail.vue?vue&type=template&id=14731122&ts=true"
import script from "./BusinessUnitsDetail.vue?vue&type=script&lang=ts"
export * from "./BusinessUnitsDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__